function mobileChecker(mobile: string): boolean {
  const mobileRgx = /^(\+98|0)( |-){0,1}9\d{2}( |-){0,1}\d{3}( |-){0,1}\d{4}$/;
  return mobileRgx.test(mobile);
}

function nameChecker(name: string): boolean {
  const nameRgx =
    /^[A-Za-z\u0621-\u0628\u062A-\u063A\u0641-\u0642\u0644-\u0648\u064E-\u0651\u0655\u067E\u0686\u0698\u06A9\u06AF\u06BE\u06CC\s]*$/;
  return nameRgx.test(name);
}

function checkFontClassExistence(text: string): boolean {
  return (
    /title-h[2-5]-[mb]/.test(text) ||
    /txt-(t[12]-[lrm]|t3-m)/.test(text) ||
    /desc-([lrm]|c-l)/.test(text)
  );
}

function checkPaddingMarginClassExistence(
  text: string,
  type: "padding" | "margin",
  position: "y" | "x" | "t" | "b" | "l" | "r" | ""
) {
  let theRegex = type === "padding" ? "pd-" : "mr-";
  switch (position) {
    case "y":
      theRegex += "([ytb]*-?)";
      break;
    case "t":
      theRegex += "([yt]*-?)";
      break;
    case "b":
      theRegex += "([yb]*-?)";
      break;
    case "x":
      theRegex += "([xlr]*-?)";
      break;
    case "l":
      theRegex += "([xl]*-?)";
      break;
    case "r":
      theRegex += "([xr]*-?)";
      break;
    default:
  }
  theRegex += "(0|4|6|8|12|14|16|20|24|32|36|40|64|72|96|120|144|168)";

  return new RegExp(theRegex).test(text);
}

export {
  mobileChecker,
  nameChecker,
  checkFontClassExistence,
  checkPaddingMarginClassExistence,
};
